module.exports = __webpack_public_path__ + "static/media/couple_moving.60c47443.svg";